import { useMemo } from 'react';
// @ts-ignore type
import data from '@/data/airplane.json';

export interface IAirplaneInfo {
  company?: string;
  model?: string;
  startPosition?: string;
  endPosition?: string;
  startTime?: string;
  endTime?: string;
  stay?: string;
}

export default function useAirplane(no?: string) {
  const info = useMemo(() => {
    if (!no) return undefined;
    return (data as Record<string, IAirplaneInfo>)[no];
  }, [no]);
  return info;
}

export const useAirplaneList = ({ withInfo }: { withInfo?: boolean }) => {
  return Object.entries(data).map(([no, info]) => ({
    label: no,
    value: no,
    ...(withInfo ? info : {}),
  }));
};
